import {Environment} from '../../environment/environment';
import {TvshopConstants} from '../../tvshop-constants';
import {OmapiIdsUtils} from '../omapi-ids/omapi-ids-utils';

export class ImageUtils {

  static getLogoUrlForOmapiId(omapiId: string, componentName?: string): string {
    return omapiId ? Environment.environmentConfig().baseUrl +
      TvshopConstants.IMAGES_AEM_PATH +
      OmapiIdsUtils.getCorrectIdForResource(omapiId) +
      (componentName ? '-' + componentName : '') +
      '-logo.png' : '';
  }

  static getBackgroundImageUrl(omapiId: string, componentName: string, extension: string = '.jpg'): string {
    return Environment.environmentConfig().baseUrl +
      TvshopConstants.IMAGES_AEM_PATH +
      OmapiIdsUtils.getCorrectIdForResource(omapiId) + '-' +
      componentName + extension;
  }

  static getBannerImageUrl(omapiId: string, componentName: string): string {
    return Environment.environmentConfig().baseUrl +
      TvshopConstants.IMAGES_AEM_PATH +
      OmapiIdsUtils.getCorrectIdForResource(omapiId) + '-' +
      componentName + '-banner.png';
  }

  static getQrCodeImageUrl(prefix: string, language: string): string {
    return Environment.environmentConfig().baseUrl +
      TvshopConstants.IMAGES_AEM_PATH +
      `${prefix}-${language}.png`;
  }
}
